var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    {
      staticClass: "app-container",
      staticStyle: { position: "relative", height: "100%", padding: "15px" },
    },
    [
      _c(
        "el-dialog",
        {
          directives: [
            {
              name: "loading",
              rawName: "v-loading",
              value: _vm.dialogSubLoading,
              expression: "dialogSubLoading",
            },
          ],
          attrs: {
            "append-to-body": "",
            top: _vm.dialogTopMargin,
            title: _vm.funcName + "維護",
            visible: _vm.dialogSubVisible,
            width: "90%",
          },
          on: {
            "update:visible": function ($event) {
              _vm.dialogSubVisible = $event
            },
          },
        },
        [
          _c(
            "el-card",
            { staticClass: "box-card" },
            [
              _c(
                "el-row",
                [
                  _c(
                    "el-col",
                    {
                      staticStyle: { "text-align": "center" },
                      attrs: { span: 9 },
                    },
                    [
                      _vm.subImgInfo.file
                        ? _c("el-image", {
                            staticStyle: { height: "500px" },
                            attrs: {
                              src: _vm.subImgInfo.file.url,
                              fit: "contain",
                            },
                          })
                        : _vm._e(),
                    ],
                    1
                  ),
                  _c(
                    "el-col",
                    { attrs: { span: 15 } },
                    [
                      _vm.subImgInfo.info
                        ? _c(
                            "el-form",
                            { attrs: { "label-width": "80px" } },
                            [
                              _c(
                                "el-form-item",
                                { attrs: { label: "檔案名稱" } },
                                [
                                  _vm._v(
                                    " " +
                                      _vm._s(
                                        _vm.subImgInfo.info.fileInfo
                                          .fileRealName
                                      ) +
                                      " "
                                  ),
                                ]
                              ),
                              _c(
                                "el-form-item",
                                { attrs: { label: "上傳者" } },
                                [
                                  _vm._v(
                                    " " +
                                      _vm._s(
                                        _vm.subImgInfo.info.userInfo.name
                                      ) +
                                      " "
                                  ),
                                ]
                              ),
                              _c(
                                "el-form-item",
                                { attrs: { label: "上傳時間" } },
                                [
                                  _vm._v(
                                    " " +
                                      _vm._s(
                                        _vm.subImgInfo.info.fileInfo.buildDate
                                      ) +
                                      " "
                                  ),
                                ]
                              ),
                            ],
                            1
                          )
                        : _vm._e(),
                    ],
                    1
                  ),
                ],
                1
              ),
            ],
            1
          ),
          _c(
            "span",
            {
              staticClass: "dialog-footer action-buttons",
              attrs: { slot: "footer" },
              slot: "footer",
            },
            [
              _c(
                "el-button",
                {
                  attrs: { type: "success" },
                  on: {
                    click: function ($event) {
                      return _vm.downloadFile(
                        _vm.subImgInfo.file.id,
                        _vm.subImgInfo.file.fileName
                      )
                    },
                  },
                },
                [_vm._v("下 載")]
              ),
              _c(
                "el-popconfirm",
                {
                  attrs: {
                    title: "確定要刪除這張照片嗎？",
                    "cancel-button-text": "取消",
                    "confirm-button-text": "確定",
                  },
                  on: {
                    confirm: function ($event) {
                      return _vm.handleDeleteImage(_vm.subImgInfo.file.id)
                    },
                  },
                },
                [
                  _c(
                    "el-button",
                    {
                      attrs: { slot: "reference", type: "danger" },
                      slot: "reference",
                    },
                    [_vm._v("刪 除")]
                  ),
                ],
                1
              ),
              _c(
                "el-button",
                {
                  on: {
                    click: function ($event) {
                      _vm.dialogSubVisible = false
                    },
                  },
                },
                [_vm._v("關 閉")]
              ),
            ],
            1
          ),
        ],
        1
      ),
      _c(
        "el-dialog",
        {
          directives: [
            {
              name: "loading",
              rawName: "v-loading",
              value: _vm.dialogLoading,
              expression: "dialogLoading",
            },
          ],
          attrs: {
            top: _vm.dialogTopMargin,
            title: _vm.funcName + "維護",
            visible: _vm.dialogVisible,
            width: "90%",
          },
          on: {
            open: _vm.resetAlbumSelection,
            "update:visible": function ($event) {
              _vm.dialogVisible = $event
            },
          },
        },
        [
          _c(
            "div",
            {
              staticStyle: {
                color: "red",
                "font-size": "12px",
                "margin-bottom": "10px",
              },
            },
            [_vm._v(" 提示：第一次下載需要比較長時間處理，請耐心等候。 ")]
          ),
          _c(
            "el-card",
            { staticClass: "box-card" },
            [
              _c(
                "el-row",
                { staticStyle: { "margin-bottom": "10px" } },
                [
                  _c(
                    "el-form",
                    { staticClass: "imageUpload", attrs: { inline: true } },
                    [
                      _c(
                        "el-form-item",
                        { attrs: { label: "圖片下載/刪除" } },
                        [
                          _c(
                            "el-checkbox-group",
                            {
                              on: { change: _vm.handleSelectList },
                              model: {
                                value: _vm.downloadType,
                                callback: function ($$v) {
                                  _vm.downloadType = $$v
                                },
                                expression: "downloadType",
                              },
                            },
                            [
                              _c(
                                "el-checkbox",
                                { attrs: { label: "agency" } },
                                [_vm._v("旅行社全部")]
                              ),
                              _c(
                                "el-checkbox",
                                { attrs: { label: "leader" } },
                                [_vm._v("領隊全部")]
                              ),
                              _c(
                                "el-checkbox",
                                { attrs: { label: "travelers" } },
                                [_vm._v("旅客全部")]
                              ),
                              _c("el-checkbox", { attrs: { label: "all" } }, [
                                _vm._v("全選"),
                              ]),
                            ],
                            1
                          ),
                        ],
                        1
                      ),
                      _c(
                        "el-form-item",
                        [
                          !_vm.showChk
                            ? _c(
                                "el-button",
                                {
                                  attrs: { type: "primary", size: "mini" },
                                  on: { click: _vm.enablePhotoSelection },
                                },
                                [_vm._v(" 選取照片 ")]
                              )
                            : _vm._e(),
                          _vm.imageIDs.length > 0
                            ? _c(
                                "el-tag",
                                { staticStyle: { "margin-left": "10px" } },
                                [
                                  _vm._v(
                                    _vm._s(
                                      "共選擇 " +
                                        _vm.imageIDs.length +
                                        " 張照片"
                                    ) + " "
                                  ),
                                ]
                              )
                            : _vm._e(),
                          _vm.showChk
                            ? _c(
                                "el-button",
                                {
                                  staticStyle: { "margin-top": "10px" },
                                  attrs: { type: "warning", size: "mini" },
                                  on: { click: _vm.cancelSelect },
                                },
                                [_vm._v("取消選取")]
                              )
                            : _vm._e(),
                        ],
                        1
                      ),
                    ],
                    1
                  ),
                ],
                1
              ),
              _c(
                "el-tabs",
                {
                  attrs: { type: "border-card" },
                  model: {
                    value: _vm.activeAlbumName,
                    callback: function ($$v) {
                      _vm.activeAlbumName = $$v
                    },
                    expression: "activeAlbumName",
                  },
                },
                _vm._l(_vm.albumTypes, function (albumType) {
                  return _c(
                    "el-tab-pane",
                    {
                      key: albumType.name,
                      attrs: { label: albumType.label, name: albumType.name },
                    },
                    [
                      _c("AlbumGallery", {
                        attrs: {
                          albums: _vm.filteredAlbums[albumType.albumKey],
                          "group-tags": _vm.albumGroupTag,
                          "selected-group-tag": _vm.selectedAlbumGroupTag,
                          "selected-image-ids": _vm.imageIDs,
                          "show-selection": _vm.showChk,
                          "show-group-tags":
                            _vm.downloadType.length === 0 ||
                            _vm.downloadType[0] === "cancelCheck",
                          loading: _vm.spinLoading,
                          "has-more": _vm.activeAlbumHasMore,
                          "load-more-loading": _vm.albumPageLoading,
                        },
                        on: {
                          "update:selectedImageIds": function ($event) {
                            _vm.imageIDs = $event
                          },
                          "update:selected-image-ids": function ($event) {
                            _vm.imageIDs = $event
                          },
                          "select-group-tag": _vm.handleSelectGroupTag,
                          "delete-group-tag": _vm.handleDeleteConfirm,
                          "check-image": _vm.checkImage,
                          "load-more": function ($event) {
                            return _vm.loadMoreAlbums(albumType.name)
                          },
                        },
                      }),
                    ],
                    1
                  )
                }),
                1
              ),
            ],
            1
          ),
          _c(
            "span",
            {
              staticClass: "dialog-footer action-buttons",
              attrs: { slot: "footer" },
              slot: "footer",
            },
            [
              _vm.imageIDs.length > 0
                ? _c(
                    "el-button",
                    {
                      attrs: { type: "success" },
                      on: { click: _vm.downloadImages },
                    },
                    [_vm._v("下 載")]
                  )
                : _vm._e(),
              _vm.activeAlbumName == "agency" && _vm.imageIDs.length > 0
                ? _c(
                    "el-popconfirm",
                    {
                      attrs: {
                        title: "確定要刪除選取的照片嗎？",
                        "cancel-button-text": "取消",
                        "confirm-button-text": "確定",
                      },
                      on: { confirm: _vm.handleDeleteImages },
                    },
                    [
                      _c(
                        "el-button",
                        {
                          attrs: { slot: "reference", type: "danger" },
                          slot: "reference",
                        },
                        [_vm._v("刪 除")]
                      ),
                    ],
                    1
                  )
                : _vm._e(),
              _c(
                "el-button",
                {
                  on: {
                    click: function ($event) {
                      _vm.dialogVisible = false
                    },
                  },
                },
                [_vm._v("關 閉")]
              ),
            ],
            1
          ),
        ],
        1
      ),
      _c(
        "el-form",
        {
          staticClass: "filter-form",
          attrs: { inline: true },
          nativeOn: {
            submit: function ($event) {
              $event.preventDefault()
            },
          },
        },
        [
          _c(
            "el-form-item",
            { attrs: { label: "查詢" } },
            [
              _c("el-input", {
                attrs: { placeholder: "輸入團號或團名" },
                nativeOn: {
                  keyup: function ($event) {
                    if (
                      !$event.type.indexOf("key") &&
                      _vm._k($event.keyCode, "enter", 13, $event.key, "Enter")
                    ) {
                      return null
                    }
                    return _vm.getAgencyTravels($event)
                  },
                },
                model: {
                  value: _vm.listQuery.qry,
                  callback: function ($$v) {
                    _vm.$set(_vm.listQuery, "qry", $$v)
                  },
                  expression: "listQuery.qry",
                },
              }),
            ],
            1
          ),
          _c("el-button", {
            staticStyle: { "margin-top": "8px", "margin-left": "5px" },
            attrs: {
              type: "primary",
              icon: "el-icon-search",
              circle: "",
              disabled: _vm.listLoading,
            },
            on: { click: _vm.getAgencyTravels },
          }),
          _c("el-button", {
            staticStyle: { cursor: "pointer" },
            attrs: {
              type: "success",
              loading: _vm.listLoading,
              circle: "",
              icon: "el-icon-refresh-left",
            },
            on: {
              click: function ($event) {
                return _vm.refresh()
              },
            },
          }),
        ],
        1
      ),
      _c(
        "div",
        {
          directives: [
            {
              name: "loading",
              rawName: "v-loading",
              value: _vm.listLoading,
              expression: "listLoading",
            },
          ],
          staticStyle: { position: "relative", height: "80%" },
        },
        [
          _c(
            "el-table",
            {
              staticStyle: { width: "100%" },
              attrs: {
                size: "mini",
                data: _vm.list,
                border: "",
                height: "100%",
              },
            },
            [
              _c("el-table-column", {
                attrs: { align: "center", label: "項次", width: "60" },
                scopedSlots: _vm._u([
                  {
                    key: "default",
                    fn: function (scope) {
                      return [_c("span", [_vm._v(_vm._s(scope.$index + 1))])]
                    },
                  },
                ]),
              }),
              _c("el-table-column", {
                attrs: {
                  prop: "tourGroupNo",
                  label: "團號",
                  width: "200",
                  align: "center",
                },
              }),
              _c("el-table-column", {
                attrs: { align: "center", label: "團名", width: "450" },
                scopedSlots: _vm._u([
                  {
                    key: "default",
                    fn: function (ref) {
                      var row = ref.row
                      return [
                        _c("span", [_vm._v(_vm._s(row.travelName))]),
                        _c(
                          "div",
                          [
                            _c(
                              "el-tag",
                              { staticStyle: { "font-size": "14px" } },
                              [
                                _vm._v(" 出發 "),
                                _c("span", { staticStyle: { color: "red" } }, [
                                  _vm._v(
                                    _vm._s(row.beginDate + " " + row.beginTime)
                                  ),
                                ]),
                                _vm._v(" - 回程 "),
                                _c("span", { staticStyle: { color: "red" } }, [
                                  _vm._v(
                                    _vm._s(row.endDate + " " + row.endTime)
                                  ),
                                ]),
                              ]
                            ),
                          ],
                          1
                        ),
                      ]
                    },
                  },
                ]),
              }),
              _c("el-table-column", {
                attrs: { align: "center", label: "查看相簿", width: "100" },
                scopedSlots: _vm._u([
                  {
                    key: "default",
                    fn: function (scope) {
                      return [
                        _c(
                          "el-button",
                          {
                            attrs: { size: "mini", type: "info" },
                            on: {
                              click: function ($event) {
                                return _vm.getAlbum(scope.row.id)
                              },
                            },
                          },
                          [_vm._v("查看")]
                        ),
                      ]
                    },
                  },
                ]),
              }),
              _c("el-table-column", {
                attrs: { align: "center", label: "上傳圖片", width: "100" },
                scopedSlots: _vm._u([
                  {
                    key: "default",
                    fn: function (scope) {
                      return [
                        _c(
                          "div",
                          {
                            on: {
                              click: function ($event) {
                                return _vm.getPhotoToPublicAlbumGroupTag(
                                  scope.row.id,
                                  true
                                )
                              },
                            },
                          },
                          [
                            _c("MultipleImage", {
                              attrs: {
                                title:
                                  "上傳圖片（團號：" +
                                  scope.row.tourGroupNo +
                                  "）",
                                travelId: scope.row.id,
                                groupNo: scope.row.tourGroupNo,
                                albumGroupTag: _vm.albumGroupTag,
                              },
                              on: {
                                getGroupTagList: function ($event) {
                                  return _vm.getPhotoToPublicAlbumGroupTag(
                                    scope.row.id,
                                    true
                                  )
                                },
                              },
                            }),
                          ],
                          1
                        ),
                      ]
                    },
                  },
                ]),
              }),
            ],
            1
          ),
          _c("pagination", {
            directives: [
              {
                name: "show",
                rawName: "v-show",
                value: _vm.total > 0,
                expression: "total > 0",
              },
            ],
            attrs: {
              layout: "prev, pager, next",
              total: _vm.total,
              page: _vm.listQuery.page,
              limit: _vm.listQuery.limit,
            },
            on: {
              "update:page": function ($event) {
                return _vm.$set(_vm.listQuery, "page", $event)
              },
              "update:limit": function ($event) {
                return _vm.$set(_vm.listQuery, "limit", $event)
              },
              pagination: _vm.getAgencyTravels,
            },
          }),
        ],
        1
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }